var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/parser/geojsonvt.ts
import geojsonvt from "geojson-vt";
import VtSource from "../source/geojsonvt";
var DEFAULT_CONFIG = {
  tileSize: 256,
  minZoom: 0,
  maxZoom: Infinity,
  zoomOffset: 0
};
function signedArea(ring) {
  let sum = 0;
  for (let i = 0, len = ring.length, j = len - 1, p1, p2; i < len; j = i++) {
    p1 = ring[i];
    p2 = ring[j];
    sum += (p2.x - p1.x) * (p1.y + p2.y);
  }
  return sum;
}
function classifyRings(rings) {
  const len = rings.length;
  if (len <= 1) {
    return [rings];
  }
  const polygons = [];
  let polygon;
  let ccw;
  for (let i = 0; i < len; i++) {
    const area = signedArea(rings[i]);
    if (area === 0) {
      continue;
    }
    if (ccw === void 0) {
      ccw = area < 0;
    }
    if (ccw === area < 0) {
      if (polygon) {
        polygons.push(polygon);
      }
      polygon = [rings[i]];
    } else {
      polygon.push(rings[i]);
    }
  }
  if (polygon) {
    polygons.push(polygon);
  }
  return polygons;
}
var VectorTileFeatureTypes = ["Unknown", "Point", "LineString", "Polygon"];
function GetGeoJSON(extent, x, y, z, vectorTileFeature) {
  let coords = vectorTileFeature.geometry;
  const currenType = vectorTileFeature.type;
  const currentProperties = vectorTileFeature.tags;
  const currentId = vectorTileFeature.id;
  const size = extent * Math.pow(2, z);
  const x0 = extent * x;
  const y0 = extent * y;
  let type = VectorTileFeatureTypes[currenType];
  let i;
  let j;
  function project(line) {
    for (let index = 0; index < line.length; index++) {
      const p = line[index];
      if (p[3]) {
        break;
      }
      const y2 = 180 - (p[1] + y0) * 360 / size;
      const lng = (p[0] + x0) * 360 / size - 180;
      const lat = 360 / Math.PI * Math.atan(Math.exp(y2 * Math.PI / 180)) - 90;
      line[index] = [lng, lat, 0, 1];
    }
  }
  switch (currenType) {
    case 1:
      const points = [];
      for (i = 0; i < coords.length; i++) {
        points[i] = coords[i][0];
      }
      coords = points;
      project(coords);
      break;
    case 2:
      for (i = 0; i < coords.length; i++) {
        project(coords[i]);
      }
      break;
    case 3:
      coords = classifyRings(coords);
      for (i = 0; i < coords.length; i++) {
        for (j = 0; j < coords[i].length; j++) {
          project(coords[i][j]);
        }
      }
      break;
  }
  if (coords.length === 1) {
    coords = coords[0];
  } else {
    type = "Multi" + type;
  }
  const result = {
    type: "Feature",
    geometry: {
      type,
      coordinates: coords
    },
    properties: currentProperties,
    id: currentId,
    tileOrigin: [0, 0],
    coord: ""
  };
  return result;
}
var getVectorTile = (tile, tileIndex, tileParams, extent) => __async(void 0, null, function* () {
  return new Promise((resolve) => {
    const tileData = tileIndex.getTile(tile.z, tile.x, tile.y);
    const features = tileData ? tileData.features.map((vectorTileFeature) => {
      return GetGeoJSON(extent, tileParams.x, tileParams.y, tileParams.z, vectorTileFeature);
    }) : [];
    const vectorTile = {
      layers: {
        defaultLayer: {
          // @ts-ignore
          features
        }
      }
    };
    const vectorSource = new VtSource(vectorTile, tile.x, tile.y, tile.z);
    resolve(vectorSource);
  });
});
function getOption(cfg) {
  const defaultOptions = {
    // geojson-vt default options
    maxZoom: 14,
    // max zoom to preserve detail on
    indexMaxZoom: 5,
    // max zoom in the tile index
    indexMaxPoints: 1e5,
    // max number of points per tile in the tile index
    tolerance: 3,
    // simplification tolerance (higher means simpler)
    extent: 4096,
    // tile extent
    buffer: 64,
    // tile buffer on each side
    lineMetrics: false,
    // whether to calculate line metrics
    promoteId: null,
    // name of a feature property to be promoted to feature.id
    generateId: true,
    // whether to generate feature ids. Cannot be used with promoteId
    debug: 0
    // logging level (0, 1 or 2)
  };
  if (cfg === void 0 || typeof cfg.geojsonvtOptions === "undefined") {
    return defaultOptions;
  } else {
    return __spreadValues(__spreadValues({}, defaultOptions), cfg.geojsonvtOptions);
  }
}
function geojsonVTTile(data, cfg) {
  const geojsonOptions = getOption(cfg);
  const extent = geojsonOptions.extent || 4096;
  const tileIndex = geojsonvt(data, geojsonOptions);
  const getTileData = (tileParams, tile) => {
    return getVectorTile(tile, tileIndex, tileParams, extent);
  };
  const tilesetOptions = __spreadProps(__spreadValues(__spreadValues({}, DEFAULT_CONFIG), cfg), {
    getTileData
  });
  return {
    data,
    dataArray: [],
    tilesetOptions,
    isTile: true
  };
}
export {
  geojsonVTTile as default
};
